import * as React from "react"
import { InformationCircleIcon } from "@heroicons/react/solid"

const Small = ({ blok, len }) => <h1 className="pb-4">{blok.Small}</h1>

export default Small
